<template>
  <v-dialog @click:outside="closeDialog" :value="dialog" max-width="700px" :persistent="true">
    <v-card>

      <v-card-title class="justify-space-between pa-5">
        <h3>{{ $store.getters.t('업로드') }}</h3>
        <!-- <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn> -->
      </v-card-title>
      
      <v-card-title class="btn-mobile-align pt-0">
        <v-row>
          <v-col>
            <v-row>
              <span class="mr-1" style="color: #888; font-size: 16px; font-weight: 200;">
                {{ $store.getters.t('현재 업로드 옵션은') }} <b style="color: #007bff;">{{ $store.getters.t(uploadStatus) }}</b> {{ $store.getters.t('입니다.') }}
              </span>

              <v-tooltip bottom color="#eef6ff" style="box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="mdi mdi-information-outline" color="#ccc"/>
                </template>
                <div style="color: #006CEA;">
                  <h4>{{ $store.getters.t('업로드 옵션 설정') }}</h4>
                <v-divider color="#4d9bf5" class="mt-1 mb-1"></v-divider>
                <span style="font-size: 12px;">{{ $store.getters.t('업로드 옵션은 설정 > 일반설정 > 업로드옵션') }}<br>{{ $store.getters.t('에서 설정할 수 있습니다.') }}</span>
                </div>
                
              </v-tooltip>

            </v-row>
          </v-col>
        </v-row>

        <div class="btn-mobile">
          <v-btn elevation="0" outlined class="mr-2 m-btn" :disabled="finishedNum" @click="removeFinishedFiles">{{ $store.getters.t('완료된 파일 삭제' )}}</v-btn>
          <v-btn elevation="0" dark class="m-btn" @click="handleFileButtonClick">{{ $store.getters.t('파일 추가') }}</v-btn>
          <input hidden id="file-selector" type="file" accept=".mp4, .mov" multiple @change="handleFileUpload"
            ref="uploader">
        </div>
      </v-card-title>
      <div class="pl-5 pr-5">
        <Alert v-if="countCheck" :message="message" :message-type="messageType"></Alert>
      </div>

      <div class="upload_box" @drop.prevent="onDrop($event)" @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true" @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover }">
        
      <!-- <Alert v-if="countCheck" :message="message" :message-type="messageType"></Alert> -->
        <v-card-text v-if="!uploadedFiles.length">
          <v-row class="d-flex flex-column" dense align="center" justify="center" style="height: 268px;">
            <v-icon :class="[dragover ? 'mt-2 mb-6' : 'mt-5']" size="60">
              mdi-cloud-upload
            </v-icon>
            <p class="mb-1">{{ $store.getters.t('파일을 이곳에 드롭하세요') }}</p>
            <span class="upload_txt">{{ $store.getters.t('업로드는 동시에 ') }}<strong>{{ $store.getters.t('최대 10개 ') }}</strong>{{ $store.getters.t('파일까지 가능합니다.') }}</span>
            <span class="mt-2" style="color: #888; font-weight: 200;">{{ $store.getters.t('파일 하나당 최대 업로드 크기') }} : 10GB</span>
            <span style="color: #888; font-weight: 200;">
              {{ $store.getters.t('지원되는 비디오 형식') }} : <b style="color: #007bff;">MP4, MOV</b>
            </span>
           
          </v-row>
        </v-card-text>
        <UploadTable :files="uploadedFiles" v-if="uploadedFiles.length" />
      </div>

      <div class="switch_box">
        <v-col>
          <span><v-icon class="mdi mdi-play-box-lock-outline mr-2"></v-icon>{{ $store.getters.t('업로드 영상 보안하기') }}</span>
        </v-col>
        <div v-show="aes == 0" >
          <v-icon class="mdi mdi-information-outline" color="#007bff"/>
          <span style="font-size: 14px; color: #007bff;"> {{ $store.getters.t('무료플랜에서는 이용할 수 없습니다.') }}</span>
        </div>
        <v-switch :disabled="aes == 0 || !isUploadButtonEnabled" v-model="switch1" inset style="width: 48px !important;height: 24px !important; margin-top: -8px;"></v-switch>
      </div>

      <div class="switch_box">
        <v-col>
          <span>
            <v-icon class="mdi mdi-robot-outline mr-2"></v-icon>
            {{ $store.getters.t ? $store.getters.t('ai.voice.toggle_label') : 'AI 음성 추출 사용하기' }}
          </span>
        </v-col>
        <div v-if="!canUseAiTranscript" class="lock-hint">
          <v-icon class="mr-1" color="#6b7280">mdi-lock</v-icon>
          <span>
            {{ $store.getters.t ? $store.getters.t('ai.voice.locked_message') : '현재 요금제에서는 AI 음성 추출을 사용할 수 없습니다.' }}
          </span>
        </div>
        <v-switch
          v-model="aiVoice"
          inset
          :disabled="!canUseAiTranscript"
          style="width: 48px !important;height: 24px !important; margin-top: -8px;"
        ></v-switch>
      </div>
      <div class="ai-desc" v-if="aiVoice && canUseAiTranscript">
        {{ $store.getters.t ? $store.getters.t('ai.voice.description') : '업로드 후 위스퍼로 영상 음성을 추출해 자막을 생성합니다.' }}
      </div>

      <v-row class="pa-5">
        <v-col>
          <!-- <v-btn elevation="0" :disabled="!isUploadButtonEnabled" :dark="uploadedFiles.length > 0"
            @click="startUpload">업로드</v-btn> -->
          <TextButtonBlock :buttonText="this.$store.getters.t('닫기')" :width="'49%'" class="mr-2" @click="closeDialog" />
          <TextButtonBlock :buttonText="this.$store.getters.t('업로드')" :width="'49%'" isPrimary :disabled="!isUploadButtonEnabled"
            :dark="uploadedFiles.length > 0" @click="startUpload" />

        </v-col>
      </v-row>

    </v-card>
  </v-dialog>
</template>


<script>
import UploadTable from '@/components/upload/Upload.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import ToolTip from '@/components/ui/toolltip/ToolTip.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import Alert from '@/components/app/AppAlert.vue';

export default {
  name: "UploadDialog",
  components: {
    UploadTable,
    TextButtonBlock,
    ToolTip,
    Alert
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dragover: false,
      formattedFileList: [],
      selectedlist: [],
      selected: [],
      switch1: null,
      message: '',
      messageType: '',
      finishedNum: true,
      aiVoice: false,
    };
  },
  beforeMount(){
    this.switch1 = this.aesVal;
  },
  computed: {
    ...mapGetters('upload', ['uploadedFiles', 'fileProgress']),
    isUploadButtonEnabled() {
      // console.log("개수 : ",this.uploadedFiles.length )
      // return this.uploadedFiles.some(file => file.status === 'pending') || this.uploadedFiles.some(file => file.status === 'resumed');
      return this.uploadedFiles.some(file => file.status === 'ready') && this.uploadedFiles.length <= 10;
        // return this.uploadedFiles.some(file => file.status === 'pending') && this.uploadedFiles.length <= 10;
      //  return this.uploadedFiles.some(file => file.status === 'waiting') && this.uploadedFiles.length <= 10;
    },
    ...mapGetters('user', ['upload', 'aesVal']),
    canUseAiTranscript() {
      return !!this.hasAiTranscript;
    },
    uploadStatus() {
      if (this.upload === 1) {
        return '업로드 + 인코딩';
      } else if (this.upload === 2) {
        return '업로드';
      } else {
        return '업로드';
      }
    },
    aesStatus(){
      if(this.aesVal == 1){
        return true;
      } else {
        return false;
      }
    },
    allowList(){
      return this.$store.state.naviList.allowList;
    },
    aes(){
      if(this.allowList){
        return this.allowList.aes;
      } else {  
        return 0; 
      }
    },
    canUseAiTranscript() {
      if (this.allowList && Object.prototype.hasOwnProperty.call(this.allowList, 'ai_transcript')) {
        return Boolean(Number(this.allowList.ai_transcript));
      }
      return false;
    },
    // finishedNum(){
    //   const count = this.uploadedFiles.filter(e => e.status === 'completed').length;
    //   if(count > 0){
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    countCheck(){
      const count = this.uploadedFiles.length;
      if(count > 10){
        this.message = "업로드는 동시에 최대 10개 파일까지 가능합니다.";
        this.messageType = "error";
        return true;
      } else {
        return false;
      }
    },
    totalCount(){
      return this.uploadedFiles.filter(e => e.status === 'completed').length;
    }
  },
  watch: {
    aesStatus : {
      async handler(newValue, oldValue) {
          if (newValue !== oldValue) {
              this.switch1 = newValue;
          }
      },
      deep: true 
    },
    totalCount: {
       async handler(newValue, oldValue) {
        if(newValue && newValue != oldValue){
          //  console.log("newValue : ", newValue)
          if(newValue > 0){
            // console.log("check")
            this.finishedNum = false;
          } else {
            this.finishedNum = true;
          }
        }
      },
      deep: true,
      immediate: true,
    },
    canUseAiTranscript(val) {
      if (!val) {
        this.aiVoice = false;
      }
    }
  },
  methods: {
    ...mapActions('upload', [
      'addUploadedFile',
      'removeUploadedFile',
      'setFileProgress',
      'initFileProgress',
      'addFiles',
      'uploadFiles',
      'removeFinished',
    ]),
    handleFileUpload(event) {
      const files = event.target.files;
      if (files.length > 0) {
        const params = {
          files: Array.from(files)
        }
        this.addFiles(params);
        event.target.value = '';
      }
    },
    startUpload() {
      this.uploadFiles({
        secure: this.switch1,
        aiVoice: this.aiVoice,
      });
    },
    closeDialog() {
      this.switch1 = this.aesStatus;
      this.aiVoice = false;
      this.$emit("update:dialog", false);
    },
    onDrop(e) {
      // console.log("drop => ", e)
      this.dragover = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        const params = {
          files: Array.from(files)
        }
        this.addFiles(params);
      }
    },
    handleFileButtonClick() {
      this.$refs.uploader.click();
    },
    removeFinishedFiles(){
      this.removeFinished();
      this.finishedNum = true;
    },
  }
};
</script>

<style scoped>
.upload_box {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 0px 20px 0px 20px;
}
.upload_txt{
  font-size: 14px;
  color: #707070;
  background: #f8f8f8;
  padding: 2px 8px 2px 8px;
  border-radius: 4px;
}

.ai-desc {
  font-size: 12px;
  color: #6b7280;
  margin: 4px 20px 16px 20px;
}
.ai-desc.warning {
  color: #6b7280;
}
.lock-hint {
  display: flex;
  align-items: center;
  color: #4b5563;
  font-size: 12px;
}
.upload_txt strong {
  color: #363636;
}
.switch_box {
  padding: 16px;
  margin: 20px;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  justify-content: space-between;
}
.switch_box span {
  margin-right: 24px;
  font-size: 14px;
}

.v-input__control { width: 48px !important; height: 24px !important; }
</style>
